import React from 'react'
import { bindActionCreators } from 'redux'
import { connect } from 'react-redux'
import {NavBar, NavBarItem} from 'react-weui';
import { browserHistory } from 'react-router'
import * as componentsAct from '../../actions/component'
// import { WKTab } from '../../components'
import '../../styles/components/WKTab.css';


class RelayTab extends React.Component {
    componentDidMount() {
        this.props.componentInitWktabPlus({
            selectId: this.props.tab === 'lecture' ? 0 : 1,
            list: [{
                name: '课程转载',
                id: 0,
            }, {
                name: '专栏转载',
                id: 1,
            }]
        })
    }
    handleSelectTab(selId) {
        this.props.componentSelectTab(selId)
        const type = selId == 0 ? 'lecture' : 'channel'
        browserHistory.replace(`/specials/relay/${type}?keyword=${this.props.query.keyword || ''}`)
    }
    render() {
        return (
            <div className="margin-bottom">
                <div className="wk-tab">
                    <NavBar className="wk-tab-navbar">
                        {this.props.wkTabList.map((item, index) => (
                            <NavBarItem data-id={item.id} key={item.id} className="wk-tab-navbar-item"
                                active={item.selected} onClick={() => this.handleSelectTab(item.id)}>{item.name}
                            </NavBarItem>
                        ))}
                    </NavBar>
                </div>
            </div>
        )
    }
}


export default connect(state => ({
    selectId: state.component.wkTab.selectId,
    wkTabList: state.component.wkTab.list
}), dispatch => bindActionCreators({ ...componentsAct }, dispatch))(RelayTab)



// WEBPACK FOOTER //
// ./src/components/relays/RelayTab.js